import styled from 'styled-components';
import { fontSize, Box, palette, spacing, Input, border } from '@landr/maestro';

const BpmControl = styled(Box)`
    width: 480px;
    height: 220px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    outline: none;

    ${({ theme }): string => theme.breakpoint('md')`
        height: auto;
        width: auto;    
    `}
`;

const InputWrapper = styled(Box)`
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: ${spacing('lg')};
`;

const Footer = styled(Box)`
    min-height: 64px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: ${spacing('lg')};
    border-top: ${border('base')};

    ${({ theme }): string => theme.breakpoint('md')`
        min-height: auto;

        padding: ${spacing('lg')} 0; 

        button span {
            font-size: ${fontSize('lg')};
        }
    `}
`;

const BpmInput = styled(Input)`
    width: 72px;
    background-color: ${palette('neutral.800')};
    color: ${palette('neutral.50')};
    border-color: ${palette('neutral.600')};

    &:hover {
        border-color: ${palette('neutral.50')};
    }

    &:focus {
        border-color: ${palette('neutral.50')};
    }

    &::placeholder {
        color: #fff;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    -moz-appearance: textfield;
`;

const SliderWrapper = styled(Box)`
    width: 100%;
    padding: ${spacing(6)} ${spacing(4)};
    float: left;
    position: relative;
    user-select: none;
`;

const SliderContent = styled(Box)`
    position: absolute;
    width: calc(100% - 28px);
    left: 14px;
`;

const SliderRail = styled(Box)`
    width: 100%;
    height: 1px;
    background-color: ${palette('neutral.600')};
`;

export const Styled = {
    BpmControl,
    InputWrapper,
    Footer,
    BpmInput,
    SliderWrapper,
    SliderContent,
    SliderRail,
};
